import { RecommendTypes } from '@doda/common/src/constants/urls';
import { adobeAnalyticsScriptsSelector } from '@doda/common/src/redux/features/analytics';
import { tlReadyExecute } from '@doda/common/src/utils/adobeAnalyticsUtil';
import { dataLayer } from '@doda/common/src/utils/googleTagManagerUtil';
import { AnalyticsAppThunk } from '@doda/common/src/types/analytics';
import { RootState } from '@doda/pc/src/redux/store';

/**
 * レコメンドカードの画像押下時の計測処理
 * @param index カード表示順
 * @param recommendType レコメンドタイプ
 * @param effectName effectName
 * @returns レコメンドカードの画像押下時の計測
 */
export const measureClickRecommendCardThumbnail =
  (
    index: number,
    recommendType: RecommendTypes,
    effectName: string
  ): AnalyticsAppThunk<RootState> =>
  (dispatch, getState) => {
    const isAdobeScript = adobeAnalyticsScriptsSelector(getState());
    const cardNumber = index + 1;
    tlReadyExecute(isAdobeScript, dispatch, 'siteRecommendTracking', {
      prop23: `Rekome_pc${cardNumber}i`,
      eVar23: 'D=c23',
      eVar103: recommendType,
      eVar104: effectName,
      eVar105: '求人一覧（通常）',
      eVar187: '求人一覧（通常）',
    });
    tlReadyExecute(
      isAdobeScript,
      dispatch,
      `KensakuKekka_Rekome_Etsuran_ChikaiKyujin_pc${index}_image`,
      {
        prop23: `Rekome_pc${cardNumber}i`,
        eVar23: 'D=c23',
      }
    );
  };

/**
 * カードのタイトル押下時の計測
 * @param index カード表示順
 * @param recommendType レコメンドタイプ
 * @param effectName effectName
 * @returns レコメンドカードのタイトル押下時の計測
 */
export const measureClickRecommendCardText =
  (
    index: number,
    recommendType: RecommendTypes,
    effectName: string
  ): AnalyticsAppThunk<RootState> =>
  (dispatch, getState) => {
    const isAdobeScript = adobeAnalyticsScriptsSelector(getState());
    const cardNumber = index + 1;
    tlReadyExecute(isAdobeScript, dispatch, 'siteRecommendTracking', {
      prop23: `Rekome_pc${cardNumber}t`,
      eVar23: 'D=c23',
      eVar103: recommendType,
      eVar104: effectName,
      eVar105: '求人一覧（通常）',
      eVar187: '求人一覧（通常）',
    });
    tlReadyExecute(
      isAdobeScript,
      dispatch,
      `KensakuKekka_Rekome_Etsuran_ChikaiKyujin${index}_pc_text`,
      {
        prop23: `Rekome_pc${cardNumber}t`,
        eVar23: 'D=c23',
      }
    );
  };

/**
 * レコメンドカードの気になる押下時の計測
 * @param jid 求人ID
 * @param index カード表示順
 * @returns レコメンドカードの気になる押下時の計測
 */
export const measureClickRecommendCardBookmark =
  (jid: string, index: number): AnalyticsAppThunk<RootState> =>
  (dispatch, getState) => {
    const cardNumber = index + 1;
    // GA計測
    dataLayer({
      click_Label: 'event70',
      click_Action: `Rekome_pc${cardNumber}k`,
      click_Category: `KensakuKekka_Rekome_Etsuran_ChikaiKyujin_pc0`,
      event: 'setEffect',
    });

    // AA計測
    const isAdobeScript = adobeAnalyticsScriptsSelector(getState());
    tlReadyExecute(isAdobeScript, dispatch, 'kininaruClick_JobSearchList_rec', {
      products: `;${jid}`,
      prop23: 'kininaru_Click',
      prop32: jid,
      eVar23: 'D=c23',
    });
  };
